import Guid from "@/app/utils/guid"
import Period from "@/common/models/periods/period"

export default class PriceHistoryFilter {
  public productId: string = Guid.empty()
  public supplierId: string = Guid.empty()
  public period: Period = new Period()
}